import React from "react";
import { FaGithub, FaLinkedin } from "react-icons/fa";
import { FaSquareXTwitter } from "react-icons/fa6";
import { HiOutlineMail } from "react-icons/hi";
import { BsFillPersonLinesFill } from "react-icons/bs";

const links = [
    {
        id: 1,
        child: <><span>LinkedIn</span><FaLinkedin size={18} /></>,
        href: "https://www.linkedin.com/in/raviraj-kumar-019956225",
    },
    {
        id: 2,
        child: <><span>Twitter</span><FaSquareXTwitter size={18} /></>,
        href: "https://twitter.com/RaviRaaZ_Tiwari",
    },
    {
        id: 3,
        child: <><span>GitHub</span><FaGithub size={18} /></>,
        href: "https://www.github.com/ravirajkumartiwari",
    },
    {
        id: 4,
        child: <><span>Email</span><HiOutlineMail size={18} /></>,
        href: "mailto:ravirajk545@gmail.com",
    },
    {
        id: 5,
        child: <><span>Resume</span><BsFillPersonLinesFill size={18} /></>,
        href: "/resume.pdf",
        download: true,
    },
];

function SocialLinks() {
    return (
        <div className="hidden lg:flex flex-col top-[38%] left-0 fixed z-30" aria-label="Social links">
            <ul>
                {links.map(({ id, child, href, download }) => (
                    <li
                        key={id}
                        className="flex justify-between items-center w-40 h-12 px-4 ml-[-108px] hover:ml-0 duration-300 ease-out"
                        style={{
                            background: "var(--clr-surface-highest)",
                            WebkitBackdropFilter: "blur(12px)",
                            backdropFilter: "blur(12px)",
                            border: "1px solid var(--clr-outline-variant)",
                            borderLeft: "none",
                            borderRadius: "0 0.375rem 0.375rem 0",
                            marginBottom: "1px",
                        }}
                    >
                        <a
                            href={href}
                            className="flex justify-between items-center w-full text-sm font-medium text-on-surface-variant hover:text-primary transition-colors"
                            download={download}
                            target={download ? undefined : "_blank"}
                            rel="noreferrer"
                        >
                            {child}
                        </a>
                    </li>
                ))}
            </ul>
        </div>
    );
}

export default SocialLinks;
